import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import Routes from "../../../../../navigation/route/Route";
import * as classNames from "classnames";
import PaymentArrivedNotification from "../../../../../model/notification/payment/PaymentArrivedNotification";
import {getLoggedUser} from "../../../../../store/view/user";

interface IComponentProps {
	/**
	 * Notification for display.
	 */
	notification: PaymentArrivedNotification;
	/**
	 * Mark notification as read.
	 */
	markReadNotification: (notificationId: string) => void;

	/**
	 * Mark notification as unread.
	 */
	markUnreadNotification: (notificationId: string) => void;
}

type Props = IComponentProps & RouteComponentProps<IComponentProps>;

class NotificationPaymentArrivedItem extends React.PureComponent<Props> {

	render() {

		const classFromProps = classNames({
			"c-notification": true,
			"active": !this.props.notification.read
		});
		const isAdmin = getLoggedUser().map(u => u.isAdmin()).getOrElse(false)


		return (
			<div className={classFromProps}>
				<div className={"notification-icon"}>
					<img src="/assets/img/icons/icon-noti-reminder.svg"/>
				</div>
				<div className={"notification-body"}>
					<div className={"notification-header"}>
						Payment arrived {this.props.notification.data.jobRefNumber.orNull} &middot;
						New Payment has arrived
					</div>
					<div className={"notification-content"}>
						{this.props.notification.displayDate()}
					</div>
					{isAdmin && <>
						<span className="notification-link" onClick={this.routeToPayment}>View payment</span>
						<span className="notification-link-separator">|</span>
					</>}
					{this.props.notification.data.jobRefNumber.map(jrn =>
						<>
							<span className="notification-link" onClick={() => this.routeToInvoice(jrn)}>View invoice</span>
							<span className="notification-link-separator">|</span>
						</>).orNull}
					{this.renderNotificationActions()}
				</div>
			</div>
		);
	}

	/**
	 * Render notification actions.
	 */
	renderNotificationActions() {
		if (this.props.notification.read) {
			return <span className="notification-link"
						 onClick={() => this.props.markUnreadNotification(this.props.notification.id)}>Mark as Unread</span>;
		}
		return <span className="notification-link" onClick={() => this.props.markReadNotification(this.props.notification.id)}>Mark as Read</span>;
	}

	/**
	 * Route to Proper transaction.
	 */
	routeToPayment = () => {
		this.props.history.push(Routes.TransactionDetailsView(this.props.notification.data.transactionId));
	}

	routeToInvoice = (jrn: string) => {
		this.props.history.push(Routes.InvoiceDetailsView(jrn));
	}
}

export default withRouter<IComponentProps>(NotificationPaymentArrivedItem);
